import React, { useEffect, useRef, useMemo } from 'react';
import SaveRef from './SaveRef';
import ScrollableTabBarNode from './ScrollableTabBarNode';
import TabBarRootNode from './TabBarRootNode';
import TabBarTabsNode from './TabBarTabsNode';
import { ScrollableInkTabBarProps, TabBarTabsNodeProps } from './iTabs'

const ScrollableInkTabBar: React.FC<ScrollableInkTabBarProps> = (props) => {
    const { children: renderTabBarNode, onTabClick, ...restProps } = props;
    const rangeKey = useMemo(() => new Date().getTime().toString(), []);
    const onTabClickRef = useRef(onTabClick);

    useEffect(() => {
        onTabClickRef.current = onTabClick;
    }, [onTabClick]);

    useEffect(() => {
        const handleDNDClick = (e: any) => {
            if (e && e.detail && e.detail.key) onTabClickRef.current?.(e.detail.key);
        };

        const timer = setTimeout(() => {
            const element = document.querySelector(`div[domkey="tabbar${rangeKey}"]`);
            if (element) element.addEventListener('DNDclick', handleDNDClick);
        }, 0);

        return () => {
            clearTimeout(timer);
            const element = document.querySelector(`div[domkey="tabbar${rangeKey}"]`);
            if (element) element.removeEventListener('DNDclick', handleDNDClick);
        };
    }, [rangeKey]); // 只依赖 rangeKey，不依赖 handleDNDClick

    return (
        <SaveRef>
            {(saveRef, getRef: (name: string) => HTMLElement) => (
                <TabBarRootNode saveRef={saveRef} {...restProps} domkey={`tabbar${rangeKey}`}>
                    <ScrollableTabBarNode saveRef={saveRef} getRef={getRef} {...restProps} onTabClick={onTabClick}>
                        <TabBarTabsNode saveRef={saveRef} renderTabBarNode={renderTabBarNode as TabBarTabsNodeProps['renderTabBarNode']} {...restProps} onTabClick={onTabClick} />
                    </ScrollableTabBarNode>
                </TabBarRootNode>
            )}
        </SaveRef>
    );
};

export default ScrollableInkTabBar;
